import { render, staticRenderFns } from "./OperationStopPower.vue?vue&type=template&id=8fd36906&scoped=true"
import script from "./OperationStopPower.vue?vue&type=script&lang=js"
export * from "./OperationStopPower.vue?vue&type=script&lang=js"
import style0 from "./OperationStopPower.vue?vue&type=style&index=0&id=8fd36906&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd36906",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fd36906')) {
      api.createRecord('8fd36906', component.options)
    } else {
      api.reload('8fd36906', component.options)
    }
    module.hot.accept("./OperationStopPower.vue?vue&type=template&id=8fd36906&scoped=true", function () {
      api.rerender('8fd36906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Operation/OperationStopPower/OperationStopPower.vue"
export default component.exports